<script>
export let percents;
</script>

<div class='col'>
  <div class="container row">
    <div class="bar1 row vcenter" style="width: {percents[0] * 100}%; z-index: 1" />
    <div class="bar2 row vcenter" />
  </div>
  <div class="row between text">
    <div style="color: rgb(253, 116, 118)">{Math.floor(percents[0] * 100)}%</div>
    <div style="color: rgb(48, 196, 99)">{Math.floor(percents[1] * 100)}%</div>
  </div>
</div>

<style>

.container {
  height: 26px;
  overflow: hidden;
  border-radius: 13px;
  position: relative;
  color: white;
  font-weight: bold;
}

.text {
  font-weight: bold;
}

.bar1, .bar2 {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 15px 0px 15px 15px;
}
.bar1 {
  background-color: rgb(253, 116, 118);
  max-width: calc(100% - 30px);
  min-width: 30px;
  z-index: 0;
}

.bar2 {
  background-color: rgb(48, 196, 99);
  width: 100%;
  z-index: 0;
}
</style>